export default __webpack_public_path__ + "static/media/border-color.f152e1c7.svg";